import { SONGS } from "@/music";
import { useLang } from "@/i18n";
import { api } from "@/lib/api";
import { X, Music2 } from "lucide-react";

const SpotifyIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.5 17.32c-.22.36-.68.47-1.04.25-2.86-1.75-6.46-2.14-10.7-1.18-.41.1-.82-.16-.92-.57-.1-.41.16-.82.57-.92 4.64-1.06 8.62-.6 11.83 1.36.36.22.47.69.26 1.06zm1.47-3.27c-.27.45-.86.6-1.31.32-3.27-2.01-8.26-2.6-12.13-1.42-.51.15-1.05-.13-1.21-.64-.15-.51.14-1.05.65-1.2 4.42-1.34 9.92-.69 13.68 1.62.45.28.6.87.32 1.32zm.13-3.4C15.18 8.26 8.9 8.04 5.27 9.14c-.61.18-1.26-.16-1.44-.77-.18-.61.16-1.26.77-1.44 4.17-1.27 11.1-1.02 15.48 1.58.55.32.73 1.03.4 1.58-.32.54-1.03.72-1.58.4z" />
  </svg>
);

export default function SoundtrackModal({ onClose }) {
  const { lang } = useLang();
  const tracks = SONGS.filter((s) => s.spotifyUrl);
  return (
    <div className="fixed inset-0 z-50 overflow-y-auto overscroll-contain flex items-start justify-center bg-black/80 backdrop-blur-sm p-4" data-testid="soundtrack-modal" onClick={onClose}>
      <div className="pixel-card bg-[#141414] w-full max-w-md max-h-full overflow-y-auto p-5 my-auto" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-4">
          <h2 className="font-pixel text-sm text-[#1DB954] pixel-stroke flex items-center gap-2"><Music2 size={16} /> {lang === "en" ? "Listen on Spotify" : "Escuchar en Spotify"}</h2>
          <button data-testid="soundtrack-close" onClick={onClose} className="text-white/70 hover:text-white"><X size={22} /></button>
        </div>
        <p className="font-vt text-base text-white/60 mb-4">{lang === "en" ? "Follow the artists behind the game on Spotify." : "Seguí a los artistas del juego en Spotify."}</p>
        <div className="flex flex-col gap-2.5">
          {tracks.map((s) => (
            <a
              key={s.id}
              href={s.spotifyUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`soundtrack-track-${s.id}`}
              onClick={() => api.trackSpotifyClick({ song_id: s.id, title: s.title || s.name, artist: s.artist || "" })}
              className="flex items-center gap-3 rounded-xl bg-white/5 hover:bg-white/10 ring-1 ring-white/10 px-3 py-2.5 transition-colors group"
            >
              <span className="shrink-0 w-9 h-9 rounded-full bg-[#1DB954] text-black flex items-center justify-center group-hover:scale-110 transition-transform">
                <SpotifyIcon size={20} />
              </span>
              <div className="min-w-0 flex-1">
                <p className="font-vt text-lg text-white truncate leading-tight">{s.title}</p>
                <p className="font-vt text-sm text-white/55 truncate">{s.artist}</p>
              </div>
              <span className="shrink-0 font-pixel text-[9px] text-[#1DB954]">{lang === "en" ? "FOLLOW" : "SEGUIR"}</span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
